<template>
    <div v-if="!showMenu & showMenu != 'undefined'">


<div>
      
  <b-carousel
    id="carousel-fade"
    style="text-shadow: 0px 0px 2px #000"
    fade
    :interval="3000"
    indicators
    img-width="1024"
    img-height="150"
  >
  <div class="menu w-100">
        <div class="container">

<newmenu class="d-none d-xl-block"/>



        </div>
        
        
        </div> 
    <b-carousel-slide
      caption=""

      img-src="./../img/slider_image_1.jpg"
     
    ></b-carousel-slide>
    <b-carousel-slide
      caption=""
      img-src="./../img/slider_image_2.jpg"
    ></b-carousel-slide>
    <b-carousel-slide
      caption=""
      img-src="./../img/slider_image_3.jpg"
    ></b-carousel-slide>
  </b-carousel>
</div>



   <!-- <div class="banner box-shadow">
       <div id="overlay"></div>

<div class="overlay-content">{{showTitle}}</div>

   </div> -->
   
    </div>
</template>

<script>
import Newmenu from './Newmenu.vue'
    export default {
  components: { Newmenu },
        name:'Header',
        data(){
          return {
            title : this.showTitle
          }
        },
        props:['PageTitle'],
        computed:{
           showMenu(){
                 return this.$store.state.auth.Menuhide
            },
            showTitle(){
                  return this.$props.PageTitle
            }

        },
          mounted() {
        this.showMenu
        

        },
        
    }
</script>

<style scoped>
.banner{
    background-image: url(../assets/bg-body.jpg);
    background-repeat: no-repeat;
    background-position: bottom;
    height: 250px;
    padding: 50px;
    text-align: center;
    color: #fff;
    background-size: cover;
    position: relative;
     box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
     /* margin-top: 40px; */
}

#overlay {
position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(0,0,0,0.5); /*dim the background*/
}

.overlay-content {
  position: relative;
  top: 18%; /* 25% from the top */
  width: 100%; /* 100% width */
  text-align: center; /* Centered text/links */
  /* margin-top: 30px; 30px top margin to avoid conflict with the close button on smaller screens */
  z-index: 333;
  font-size: 40px;
}
.menu{
    background: rgb(213, 213, 213 ,0.6);
    /* padding: 10px; */
     width: 100%;
       /* position: absolute; */
    bottom: 0;
    color: #fff;
    font-size: 14px;
  position: absolute;
  top:15px;
  z-index: 20;
  height: fit-content;
}
</style>